import {
  Component,
  Input } from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';

@Component({
  selector: 'ns-bottom-page-error',
  template: require('./bottom-page-error.component.html'),
  styles: [require('./bottom-page-error.component.scss')],
  host: { 'aria-live': 'assertive' }
})

export class BottomPageErrorComponent {
  @Input() errorObj;

  constructor(flowmanager: FlowManagerService) {
    this.flowManager = flowmanager;
  }

  ngOnChanges() {
    // Reset the error and repopulate it after so screen readers will announce it again if it hasn't changed
    this.errorBody = '';
    if (this.errorObj) {
      setTimeout(() => {
        if (this.errorObj.message) {
          this.errorBody = this.errorObj.message;
        } else {
          this.errorBody = (this.errorObj.errorCount > 1) ? `There are ${this.errorObj.errorCount}
            errors in the form you submitted.` : 'There is an error in the form you submitted.';
        }
      }, 0);
    }
  }

  closeSubmitError() {
    this.flowManager.pageError = { hasErrors: false, errorCount: 0 };
  }
}
